module.exports = __webpack_public_path__ + "img/terry.1ab0e8b4.jpg";